
import React from "react";
import {
  useParams
} from "react-router-dom";
import '../assets/css/RadioDesign.css'
import '../assets/css/Loading.css'

import ProgressBar from '../components/ProgressBar.js'
import convert from '../Helper/NumberToWord'
import Loading from '../Helper/Loading.js'
import { apiCall } from '../Service/ConnectToServer.js';
import Swal from 'sweetalert2'
import CheckVarizId from '../Helper/CheckVarizId.js'

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  FormGroup,
  Input,
  Modal,
  Form
} from "reactstrap";

function Payment() {
  let { ai, am, vi } = useParams();
  const [nextdisable, setnextDisable] = React.useState(false);
  const [PersianWord, setPersianWord] = React.useState("");
  const [AmountString, setAmountString] = React.useState(am);
  const [OrgLoading, setOrgLoading] = React.useState(true);
  const [PayLoading, setPayLoading] = React.useState(true);
  const [TaxType, setTaxType] = React.useState([]);
  const [UserOrgInfo, setUserOrgInfo] = React.useState({});
  const [TipsLoading, setTipsLoading] = React.useState(true);
  const [TipsPage, setTipsPage] = React.useState([]);
  const [BankList, setBankList] = React.useState([]);
  const [SelectBank, setSelectBank] = React.useState("");
  const [NameValidate, setNameValidate] = React.useState({
    Valid: false,
    ClassName: "",
    Message: ""
  });
  const [PhoneValidate, setPhoneValidate] = React.useState({
    Valid: false,
    ClassName: "",
    Message: ""
  });
  const [AmountValidate, setAmountValidate] = React.useState({
    Valid: false,
    ClassName: "",
    Message: ""
  });
  const [VarizValidate, setVarizValidate] = React.useState({
    Valid: false,
    ClassName: "",
    Message: ""
  });
  const [VarizDisable, setVarizDisable] = React.useState(true);
  const [TaxValidate, setTaxValidate] = React.useState({
    Valid: false,
    ClassName: "",
    Message: ""
  });
  const [ModalOpen, setModalOpen] = React.useState(false);
  const [GoToBankLoading, setGoToBankLoading] = React.useState(false);
  const [current, setcurrent] = React.useState(1);
  const [SubmitValues, setSubmitValues] = React.useState({
    BankInfoId: '',
    TaxTypeId: '',
    VarizId: vi,
    Amount: am,
    PayerName: '',
    PayerMobile: '',
    PayerEmail: '',
    Description: '',
    RefrenceType: 0
  });

  const [MellatFormSubmit, setMellatFormSubmit] = React.useState({
    RefId: '',
    Url: ''
  });

  const [PaymentRequest, setPaymentRequest] = React.useState({
    IsLoading: true,
    PaymentReceipt: {}
  });

  const SubmitClick = () => {
    if (CheckAllValidate()) {
      const config = {
        method: "Post",
        url: "Payment/PaymentRequest",
        Authorization: true,
        data: SubmitValues
      }
      apiCall(config, (response) => {
        if (response.data.Result == null) {
          Swal.fire({
            title: 'عملیات موفق',
            text: response.data.Message,
            icon: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ok'
          });
        }
        else {
          setModalOpen(true);
          if (current >= 3) {
            setnextDisable(true);
            setcurrent(4);
          }
          else {
            setcurrent(current + 1);
          }
          setPaymentRequest({
            IsLoading: false,
            PaymentReceipt: response.data.Result
          });
        }

      }, (err) => {
        console.log(err)
        Swal.fire({
          title: 'عملیات ناموفق',
          text: err,
          icon: 'error',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok'
        });
      });
    }
    else {
      Swal.fire({
        title: 'عملیات ناموفق',
        text: 'مقادیر را بدرستی وارد کنید',
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok'
      });
    }
  }

  const GoToBank = () => {
    setGoToBankLoading(true)
    var dataBank = {};
    if (PaymentRequest.PaymentReceipt.BankId === "1000") {
      dataBank = {
        Resnum: PaymentRequest.PaymentReceipt.ResNum,
        Callback: window.location.origin + "/VerifyMeli"
      }
    }
    if (PaymentRequest.PaymentReceipt.BankId === "04") {
      dataBank = {
        Resnum: PaymentRequest.PaymentReceipt.ResNum,
        Callback: window.location.origin + "/VerifyMellat"
      }
    }
    const config = {
      method: "Post",
      url: "Payment/ConfirmPayRequest",
      Authorization: true,
      data: dataBank
    }
    apiCall(config, (response) => {
      setGoToBankLoading(false)
      if (PaymentRequest.PaymentReceipt.BankId === "1000") {
        window.location.assign(response.data.Result.RedirectUrl);
      }
      else if (PaymentRequest.PaymentReceipt.BankId === "04") {
        setMellatFormSubmit({
          RefId: response.data.Result.Token,
          Url: response.data.Result.RedirectUrl
        })
        document.getElementById("formMellat").submit()
      }
    }, (err) => {

      setGoToBankLoading(false)
      Swal.fire({
        title: 'عملیات ناموفق',
        text: err,
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok'
      });
    });
  }

  const CheckAllValidate = () => {
    var result = true;
    if (TaxValidate.Valid == false) {
      setTaxValidate({
        Valid: false,
        ClassName: ValidClassName(false),
        Message: "نوع عوارض را انتخاب کنید"
      })
      result = false;
    }
    if (!VarizDisable && (VarizValidate.Valid == false)) {
      setVarizValidate({
        Valid: false,
        ClassName: ValidClassName(false),
        Message: "شناسه واریز را بدرستی وارد کنید"
      });
      result = false;
    }
    if (AmountValidate.Valid == false) {
      setAmountValidate({
        Valid: false,
        ClassName: ValidClassName(false),
        Message: "مبلغ را بدرستی وارد کنید"
      });
      result = false;
    }
    if (PhoneValidate.Valid == false) {
      setPhoneValidate({
        Valid: false,
        ClassName: ValidClassName(false),
        Message: "شماره همراه را بدرستی وارد کنید"
      });
      result = false;
    }

    if (NameValidate.Valid === false) {
      setNameValidate({
        Valid: false,
        ClassName: ValidClassName(false),
        Message: "نام‌و‌نام‌خانوادگی باید بیشتر از 5 حرف باشد"
      });
      result = false;
    }

    return result;
  }

  const ValidClassName = (input) => {
    if (input === true) {
      return "is-valid"
    }
    else return "is-invalid"
  }

  const AmountChange = (input) => {
    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "").replace(/^0+/, "");
    input = removeNonNumeric(num2en(input))
    if (!input && input === "") {
      setAmountValidate({
        Valid: false,
        ClassName: ValidClassName(false),
        Message: "مبلغ را وارد کنید"
      });
    }
    else if (input < 1) {
      setAmountValidate({
        Valid: false,
        ClassName: ValidClassName(false),
        Message: "مبلغ را بدرستی وارد کنید"
      });
    }
    else {
      setPersianWord(convert(input));
      setAmountValidate({
        Valid: true,
        ClassName: ValidClassName(true),
        Message: ""
      });
      setSubmitValues({ ...SubmitValues, Amount: input })
    }
    setAmountString(addCommas(input));
  }

  React.useEffect(() => {
    const config = {
      method: "Post",
      url: "Payment/GetUserAccount",
      Authorization: true,
      data: {}
    }
    apiCall(config, (response) => {
      setBankList(response.data.Result);
      setSelectBank(response.data.Result[0].AccountNumber);
      setSubmitValues({ ...SubmitValues, BankInfoId: response.data.Result[0].BankInfoId })
    }, (err) => {
      console.log(err)
      Swal.fire({
        title: 'عملیات ناموفق',
        text: err,
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok'
      });
    });
  }, []);

  React.useEffect(() => {
    const config = {
      method: "Post",
      url: "User/GetUserTaxType",
      Authorization: true,
      data: {}
    }
    const Orgconfig = {
      method: "Post",
      url: "User/GetUserOrganizationInfo",
      Authorization: true,
      data: {}
    }

    const Tipsconfig = {
      method: "Post",
      url: "User/GetUserTipsByPage",
      Authorization: true,
      data: { Page: 1 }
    }

    apiCall(config, (response) => {
      setPayLoading(false);
      setTaxType(response.data.Result)
    }, (err) => {
      console.log(err)
      Swal.fire({
        title: 'عملیات ناموفق',
        text: err,
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok'
      });
    });

    apiCall(Orgconfig, (response) => {
      setOrgLoading(false);
      setUserOrgInfo(response.data.Result);
    }, (err) => {
      console.log(err)
      Swal.fire({
        title: 'عملیات ناموفق',
        text: err,
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok'
      });
    });

    apiCall(Tipsconfig, (response) => {
      setTipsLoading(false);
      setTipsPage(response.data.Result);
    }, (err) => {
      console.log(err)
      Swal.fire({
        title: 'عملیات ناموفق',
        text: err,
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok'
      });
    });

  }, []);

  const ChangeRadio = (input) => {
    setSelectBank(input.AccountNumber);
    setSubmitValues({ ...SubmitValues, BankInfoId: input.BankInfoId })
  }
  
 var persinNum = [/۰/gi, /۱/gi, /۲/gi, /۳/gi, /۴/gi, /۵/gi, /۶/gi, /۷/gi, /۸/gi, /۹/gi], 
 num2en = function (str) {
    for (var i = 0; i < 10; i++) {
      str = str.replace(persinNum[i], i);
    }
    return str;
  };

  const PhoneChangeHandel = (target) => {
    var
      mobileReg = /(0|\+98)?([ ]|-|[()]){0,2}9[1|2|3|4]([ ]|-|[()]){0,2}(?:[0-9]([ ]|-|[()]){0,2}){8}/ig;

    if (num2en(target.value).match(mobileReg)) {
      setPhoneValidate({
        Valid: true,
        ClassName: ValidClassName(true),
        Message: ""
      });
      setSubmitValues({ ...SubmitValues, PayerMobile: num2en(target.value) })
    }
    else {
      setPhoneValidate({
        Valid: false,
        ClassName: ValidClassName(false),
        Message: "شماره همراه را بدرستی وارد کنید"
      });
    }
  }

  const NameChangeHandel = (target) => {
    if (target.validity.valid) {
      setNameValidate({
        Valid: true,
        ClassName: ValidClassName(true),
        Message: ""
      });
      setSubmitValues({ ...SubmitValues, PayerName: target.value })
    }
    else {
      setNameValidate({
        Valid: false,
        ClassName: ValidClassName(false),
        Message: "نام‌و‌نام‌خانوادگی باید بیشتر از 5 حرف باشد"
      });
    }
  }

  const VarizChangeHandel = (input) => {
    input=num2en(input);
    if (!input && input.trim() === "") {
      setVarizValidate({
        Valid: false,
        ClassName: ValidClassName(false),
        Message: "شناسه واریز را وارد کنید"
      })
    }
    else if (input.length < 8) {
      setVarizValidate({
        Valid: false,
        ClassName: ValidClassName(false),
        Message: " طول شناسه واریز نباید کمتر از 8 رقم باشد"
      })
    }
    else if (CheckVarizId(input)) {
      setVarizValidate({
        Valid: true,
        ClassName: ValidClassName(true),
        Message: ""
      })
      setSubmitValues({ ...SubmitValues, VarizId: num2en(input) })
    }
    else {
      setVarizValidate({
        Valid: false,
        ClassName: ValidClassName(false),
        Message: "شناسه واریز را بدرستی وارد کنید"
      })
    }

  }

  const TaxChangeHandel = (target) => {
    if (target.validity.valid) {
      setTaxValidate({
        Valid: true,
        ClassName: ValidClassName(true),
        Message: ""
      })
      var Tax = TaxType.find(element => element.ID === target.value);
      setSubmitValues({ ...SubmitValues, TaxTypeId: Tax.ID })
      if (Tax.VarizIdRequired) {
        setVarizDisable(false)
      }
      else {
        setVarizDisable(true)
      }
    }
    else {
      setTaxValidate({
        Valid: false,
        ClassName: ValidClassName(false),
        Message: "نوع عوارض را انتخاب کنید"
      })
    }

  }

  const DescriptionChangeHandel = (target) => {
    setSubmitValues({ ...SubmitValues, Description: target.value })
  }

  const ModalCloseHandel = () => {
    setModalOpen(false);
    setcurrent(1);
    setPaymentRequest({
      ...PaymentRequest,
      IsLoading: true
    });
  }

  React.useEffect(() => {
    if (am && am != "") {
      AmountChange(am);
    }
    if (vi && vi != "") {
      VarizChangeHandel(vi)
    }
  }, [am, vi])

  let bankButton;
  if (GoToBankLoading) {
    bankButton =
      bankButton = <Button style={{ float: "right", fontSize: "14px" }} color="success mr-2" onClick={() => GoToBank()}> در حال انتقال به بانک  <i class="fa fa-spinner fa-spin"></i> </Button>

  } else {
    bankButton = <Button style={{ float: "right", background: "seagreen" }} color="success mr-2" onClick={() => GoToBank()}>انتقال به درگاه بانک و پرداخت</Button>
  }



  return (
    <>
      <Form id="formMellat" name="form1" method="Post" action={MellatFormSubmit.Url}>
        <input name="RefId" type="hidden" value={MellatFormSubmit.RefId} />
      </Form>


      <Modal className="modal-lg paymodal" isOpen={ModalOpen}  >
        <div className="modal-header" style={{ boxShadow: "rgb(152 182 187) 0px 5px 18px 0px", paddingBottom: "10px" }}>
          <strong className="modal-title">صورتحساب پرداخت عوارض</strong>
          <hr />
        </div>

        <div className="modal-body">
          {PaymentRequest.IsLoading ? <Loading /> :
            <Col md="12">
              <Col md="7" >
                <Row>
                  <Col className="pr-md-1" md="12" xs="12" style={{ textAlign: "center" }}>
                    {/* <label> عنوان </label> */}
                    <strong>{PaymentRequest.PaymentReceipt.TaxType}</strong>
                  </Col>
                </Row>
                <hr style={{ marginBottom: '2px' }} />

                <Row>
                  <Col className="pr-md-1" md="6" xs="6" style={{ textAlign: "center" }}>
                    <p> شناسه واریز </p>
                    <strong>{PaymentRequest.PaymentReceipt.VarizId} </strong>
                  </Col>
                  <Col className="pr-md-1" md="6" xs="6" style={{ textAlign: "center" }}>
                    <p>  تاریخ </p>
                    <strong>{PaymentRequest.PaymentReceipt.EmissionDate}</strong>
                  </Col>
                </Row>
                <hr style={{ marginTop: '2px', marginBottom: '2px' }} />
                <Row>
                  <Col className="pr-md-1" md="6" xs="6" style={{ textAlign: "center" }}>
                    <p>نام پرداخت کننده</p>
                    <strong>{PaymentRequest.PaymentReceipt.PayerName}</strong>
                  </Col>

                  <Col className="pr-md-1" md="6" xs="6" style={{ textAlign: "center" }}>
                    <p> شماره همراه </p>
                    <strong>{PaymentRequest.PaymentReceipt.PayerMobile} </strong>
                  </Col>
                </Row>
                <hr style={{ marginTop: '2px', marginBottom: '2px' }} />
                <Row>
                  <Col className="pr-md-1" md="12" xs="12" style={{ textAlign: "center" }}>
                    <p> مبلغ پرداختی </p>
                    <strong style={{ fontSize: '28px', color: 'green' }}>{PaymentRequest.PaymentReceipt.Amount}  </strong>
                    <p>{PaymentRequest.PaymentReceipt.FaAmount}</p>
                  </Col>
                </Row>
              </Col>

              <Col md="5">
                <Card className="card-user">
                  <div>
                    <div className="author">
                      <div className="block block-one" />
                      <div className="block block-two" />
                      <div className="block block-three" />
                      <div className="block block-four" />
                      {PaymentRequest.PaymentReceipt.BankId === "1000" ?
                        <img src={require("../assets/img/BankImage/meli.png").default} alt="..."
                          className="avatar" />
                        :
                        <img src={require("../assets/img/BankImage/melat.png").default} alt="..."
                          className="avatar" />}

                      <p className="description">{PaymentRequest.PaymentReceipt.BankName}</p>
                      <Row>
                        <Col className="pr-md-1" md="6" xs="6">
                          <p>شماره حساب </p>
                          <strong>{PaymentRequest.PaymentReceipt.AccountNumber} </strong>
                        </Col>
                        <Col className="pr-md-1" md="6" xs="6">
                          <p>صاحب حساب </p>
                          <strong>{PaymentRequest.PaymentReceipt.AccountOwnerName}</strong>
                        </Col>
                      </Row>
                    </div>
                  </div>

                </Card>
              </Col>
            </Col>
          }
        </div>
        <div className="modal-footer"
          style={{ boxShadow: "rgb(152 182 187) 0px 5px 18px 0px", paddingTop: "15px", paddingBottom: "15px" }}>
          <hr />
          <Col md="12">
            {PaymentRequest.IsLoading ? "" :
              bankButton}
            <Button style={{ float: "left" }} outline color="info" onClick={() =>
              ModalCloseHandel()
            }>انصراف</Button>
          </Col>
        </div>
      </Modal>


      <div className="content text-right">
        <Row>
          <Col xs="12">
            <Card className="card-chart">
              <CardBody>
                <ProgressBar current={current} />
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col md="7" xs="12">
            <div className="card card-info">
              <CardHeader style={{ backgroundColor: "seagreen ", color: "white", padding: "20px" }}>
                <strong className={CardTitle}>پرداخت عوارض</strong>
              </CardHeader>
              <CardBody>

                {PayLoading ? <Loading /> :
                  <Col md="12">
                    <Row>
                      <Col className="pr-md-1" md="6">
                        <FormGroup>
                          <label><span style={{ color: "red" }}>*</span> پرداخت بابت :</label>
                          <Input required type="select" name="selectMulti" id="exampleSelectMulti"
                            className={TaxValidate.ClassName}
                            onChange={(event) => TaxChangeHandel(event.target)}
                          >
                            <option value="">انتخاب کنید</option>
                            {TaxType.map((input) =>
                              <option key={input.DisplayOrder} value={input.ID}>{input.Title}</option>
                            )}
                          </Input>
                          <span style={{ color: "red" }}>{TaxValidate.Message.length > 0 ? TaxValidate.Message : ""}</span>
                        </FormGroup>
                      </Col>
                      <Col className="pr-md-1" md="6">
                        <FormGroup>
                          <label><span style={{ color: "red" }}>*</span> شناسه واریز :</label>
                          <Input
                            id="VarizId"
                            required={!VarizDisable}
                            disabled={VarizDisable}
                            className={"Maxpading " + VarizValidate.ClassName}
                            style={{ color: "blue", fontSize: "140%" }}
                            defaultValue={vi}
                            placeholder="شناسه واریز (ضروری) نمونه: 97014089"
                            type="text"
                            maxLength="16"
                            minLength="8"
                            onChange={(event) => VarizChangeHandel(event.target.value)}
                          />
                          <span style={{ color: "red" }}>{VarizValidate.Message.length > 0 ? VarizValidate.Message : ""}</span>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-md-1" md="12">
                        <FormGroup>
                          <label><span style={{ color: "red" }}>*</span> مبلغ :</label>
                          <input id="input" required className={"form-control " + AmountValidate.ClassName} placeholder="مبلغ به ریال (ضروری)" maxLength="15"
                            style={{ width: "100%", textAlign: "center", fontSize: "200%", height: "50px", color: "green" }}
                            type="text" name="any" value={AmountString} onChange={(e) => AmountChange(e.target.value)}
                          ></input>
                          <strong style={{ position: "absolute", left: "20px", zIndex: "99999999", border: "none", top: "40px" }} id="basic-addon1">ریال</strong>
                          <span style={{ color: "red" }}>{AmountValidate.Message.length > 0 ? AmountValidate.Message : ""}</span>
                        </FormGroup>
                        <p>{PersianWord}</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-md-1" md="6">
                        <FormGroup>

                          <label><span style={{ color: "red" }}>*</span> نام نام خانوادگی :</label>
                          <Input
                            required
                            className={NameValidate.ClassName}
                            defaultValue=""
                            placeholder="نام و نام خانوادگی(ضروری)"
                            type="text"
                            maxLength="100"
                            minLength="5"
                            onChange={(e) => NameChangeHandel(e.target)}
                          />
                          <span style={{ color: "red" }}>{NameValidate.Message.length > 0 ? NameValidate.Message : ""}</span>
                        </FormGroup>
                      </Col>
                      <Col className="pr-md-1" md="6">
                        <FormGroup>
                          <label><span style={{ color: "red" }}>*</span> شماره همراه :</label>
                          <Input
                            required
                            className={PhoneValidate.ClassName}
                            defaultValue=""
                            placeholder="شماره موبایل جهت ارسال کد پیگیری(ضروری)"
                            type="text"
                            maxLength="11"
                            minLength="11"
                            onChange={(e) => PhoneChangeHandel(e.target)}
                          />
                          <span style={{ color: "red" }}>{PhoneValidate.Message.length > 0 ? PhoneValidate.Message : ""}</span>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="pr-md-1" md="12">
                        <FormGroup>
                          <label> توضیحات :</label>
                          <Input
                            defaultValue=""
                            placeholder="توضیحات من برای این پرداخت"
                            type="text"
                            onChange={(event) => DescriptionChangeHandel(event.target)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      {BankList.map(input =>
                        <Col className="pr-md-1" md={BankList.length > 1 ? "6" : "12"}>
                          <input type="radio" name="AccountNumber" id={input.AccountNumber} value={input.AccountNumber} checked={SelectBank === input.AccountNumber} onChange={() => ChangeRadio(input)} />
                          <label for={input.AccountNumber} className="label" aria-label="Silver">
                            <span></span>
                            {input.BankName}

                            {input.BankId === "1000" ?
                              <img src={require("../assets/img/BankImage/meli.png").default} alt="MeliImage" style={{ width: "70px", height: "60px", float: "left" }} />
                              :
                              <img src={require("../assets/img/BankImage/melat.png").default} alt="MelatImage" style={{ width: "70px", height: "60px", float: "left" }} />}

                          </label>
                        </Col>
                      )}
                    </Row>

                    <Row style={{ marginTop: "20px" }}>
                      <Col md="3"></Col>
                      <Col md="6">
                        <button style={{ width: "100%", background: "seagreen" }} className="btn btn-success" onClick={() => SubmitClick()} disabled={nextdisable}>ثبت و ادامه</button>
                      </Col>
                      <Col md="3"></Col>
                    </Row>
                  </Col>

                }
              </CardBody>
            </div>
          </Col>
          <Col md="5" xs="12">
            <Card className="card-info">
              <CardHeader>
                <strong className={CardTitle}>اطلاعات سازمانی</strong>
                <hr />
              </CardHeader>
              <CardBody>

                {OrgLoading ? <Loading /> :
                  <Row>
                    <Col className="pr-md-1" md="8" xs="8">
                      <FormGroup style={{ textAlign: "center" }}>
                        <p> نام سازمان </p>
                        <p style={{ fontSize: "18px", fontWeight: "bolder" }}>{UserOrgInfo.Org_Name}</p>
                      </FormGroup>
                      <hr />
                      <Row>
                        <Col className="pr-md-1" md="6" xs="6">
                          <FormGroup style={{ textAlign: "center" }}>
                            <p> استان </p>
                            <p style={{ fontSize: "16px", fontWeight: "bolder" }}>{UserOrgInfo.ProvinceName}</p>
                          </FormGroup>
                        </Col>
                        <Col className="pr-md-1" md="6" xs="6">
                          <FormGroup style={{ textAlign: "center" }}>
                            <p> شهر </p>
                            <p style={{ fontSize: "16px", fontWeight: "bolder" }}>{UserOrgInfo.CityName}</p>

                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>

                    <Col className="pr-md-1" md="4" xs="4">
                      <img style={{ width: "100%" }} src={UserOrgInfo.LogoUrl} alt="logoInfo" />
                    </Col>
                  </Row>
                }

              </CardBody>
            </Card>

            <Card className="card-info">
              <CardHeader>
                <strong className={CardTitle}>نکات</strong>
                <hr />
              </CardHeader>
              <CardBody>

                {TipsLoading ? <Loading /> :
                  <Row>
                    <ul style={{ listStyle: "none" }}>
                      {TipsPage.map(input =>
                        <li>
                          <i style={{ color: "blue" }} class="fa fa-circle"></i>&nbsp; {input.TipItemText} &nbsp;
                          {input.LinkCaption != null && input.LinkCaption !== "" ?
                            <a class="btn btn-blue btn-sm" href={input.LinkAddress} target="_blank" rel="noopener noreferrer">{input.LinkCaption}</a> : ''
                          }
                        </li>
                      )}
                    </ul>
                  </Row>
                }
              </CardBody>
            </Card>

          </Col>
        </Row>
      </div>
    </>
  );
}




export default Payment;
